import { render, staticRenderFns } from "./SidebarBadge.vue?vue&type=template&id=7b59e646&scoped=true&"
import script from "./SidebarBadge.vue?vue&type=script&lang=ts&"
export * from "./SidebarBadge.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarBadge.vue?vue&type=style&index=0&id=7b59e646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b59e646",
  null
  
)

export default component.exports